// deps
import React, { useContext } from "react";

// internal-deps
import { INetBankingPaymentGroup, NetBankingGroup } from "@swiggy-private/payment-ui";

// interfaces
import { PaymentGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

// hooks
import { useNetBankingHandler } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UseNetBankingHandler";

// contexts
import { NetbankingMoreBanksContext } from "@payment-client/contexts/NetbankingMoreBanksContext";

interface NetBankingGroupHandlerProps extends Omit<PaymentGroupHandlerProps, "paymentGroup"> {
    paymentGroup: INetBankingPaymentGroup["paymentData"];
    isPreferredGroup: boolean;
    showMoreBanksList?: boolean;
}

export function NetBankingGroupHandler(props: NetBankingGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, ...otherProps } = props;
    const { bankList } = useContext(NetbankingMoreBanksContext);
    const { paymentActions } = useNetBankingHandler(props);

    return (
        <NetBankingGroup
            paymentActions={paymentActions}
            netBankingList={bankList}
            paymentData={paymentGroup}
            {...otherProps}
        />
    );
}
